import { createFileRoute } from "@tanstack/react-router";

import AccountsOverview from "@/components/[routes]/accounts/accounts-overview";

export const Route = createFileRoute("/_secure/accounts/")({
  component: AccountsOverview,
});
